/**
 * @module expenseStatus
 * @description A list of expenseStatus
 */

export const expenseStatus = [
	'cancelled',
	'completed',
	'failed',
	'pending',
	'refunded',
] as const;
export type ExpenseStatus = (typeof expenseStatus)[number];
